"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wizardVerticalStepsContainerContent = exports.wizardVerticalStepsContainerWrapper = exports.wizardVerticalStepsContainerAdornment = exports.wizardVerticalStepsContainer = exports.wizardStep = exports.wizardLineCustom = exports.wizardLineLastStep = exports.wizardLineVertical = exports.wizardLine = exports.wizardSuccess = exports.wizardDisabled = exports.wizardActive = exports.wizardBulletWithIcon = exports.wizardBulletLarge = exports.wizardBulletCustom = exports.wizardBulletRegular = exports.wizardBulletSmall = exports.wizardBulletVertical = exports.wizardBullet = exports.wizardContainer = exports.wizardContainerVertical = exports.wizardWrapperVertical = exports.wizardWrapper = void 0;

var _stylitas = require("@creditas/stylitas");

const wizardWrapper = () => (0, _stylitas.css)``;

exports.wizardWrapper = wizardWrapper;

const wizardWrapperVertical = ({
  direction
}) => direction === 'vertical' && (0, _stylitas.css)`
    width: 32px;
    height: auto;
  `;

exports.wizardWrapperVertical = wizardWrapperVertical;

const wizardContainer = () => (0, _stylitas.css)`
  margin-right: auto;
  margin-left: auto;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 75rem;
`;

exports.wizardContainer = wizardContainer;

const wizardContainerVertical = ({
  direction
}) => direction === 'vertical' && (0, _stylitas.css)`
    flex-direction: column;

    & > div {
      flex-direction: column;
      height: auto;
    }
  `;

exports.wizardContainerVertical = wizardContainerVertical;

const wizardBullet = ({
  theme
}) => (0, _stylitas.css)`
  border: 1px solid;
  background-color: ${_stylitas.utilities.palette.color(theme, 'neutral01')};
  margin: 16px;
  border-radius: 50%;
  display: block;
`;

exports.wizardBullet = wizardBullet;

const wizardBulletVertical = ({
  direction
}) => direction === 'vertical' && (0, _stylitas.css)`
    margin: 16px 0;
  `;

exports.wizardBulletVertical = wizardBulletVertical;

const wizardBulletSmall = () => (0, _stylitas.css)`
  min-width: 10px;
  min-height: 10px;
  max-width: 10px;
  max-height: 10px;
`;

exports.wizardBulletSmall = wizardBulletSmall;

const wizardBulletRegular = ({
  theme,
  variant
}) => variant === 'active' && (0, _stylitas.css)`
    border: 2px solid ${_stylitas.utilities.palette.color(theme, 'secondary05')};
    min-width: 24px;
    min-height: 24px;
    max-width: 24px;
    max-height: 24px;
  `;

exports.wizardBulletRegular = wizardBulletRegular;

const wizardBulletCustom = ({
  theme,
  variant,
  color,
  backgroundColor
}) => variant === 'custom' && (0, _stylitas.css)`
    border-color: ${color ? _stylitas.utilities.palette.color(theme, color) : theme.bColorneutral05};
    background-color: ${backgroundColor ? _stylitas.utilities.palette.color(theme, backgroundColor) : theme.bColorneutral00};
  `;

exports.wizardBulletCustom = wizardBulletCustom;

const wizardBulletLarge = ({
  variant
}) => variant === 'custom' && (0, _stylitas.css)`
    min-width: 32px;
    min-height: 32px;
    max-width: 32px;
    max-height: 32px;
  `;

exports.wizardBulletLarge = wizardBulletLarge;

const wizardBulletWithIcon = ({
  icon
}) => icon && (0, _stylitas.css)`
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    & > * {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  `;

exports.wizardBulletWithIcon = wizardBulletWithIcon;

const wizardActive = ({
  theme,
  variant
}) => variant === 'active' && (0, _stylitas.css)`
    border-color: ${theme.bLabelactionColor};
  `;

exports.wizardActive = wizardActive;

const wizardDisabled = ({
  theme,
  variant
}) => variant === 'disabled' && (0, _stylitas.css)`
    border-color: ${_stylitas.utilities.palette.color(theme, 'neutral04')};
  `;

exports.wizardDisabled = wizardDisabled;

const wizardSuccess = ({
  theme,
  variant
}) => variant === 'success' && (0, _stylitas.css)`
    border-color: ${_stylitas.utilities.palette.color(theme, 'success')};
  `;

exports.wizardSuccess = wizardSuccess;

const wizardLine = ({
  lineStyle = 'dashed'
}) => (0, _stylitas.css)`
  border: 1px ${lineStyle};
  border-spacing: 2px;
  height: 1px;
  width: 100%;
`;

exports.wizardLine = wizardLine;

const wizardLineLastStep = ({
  lastStep
}) => lastStep && (0, _stylitas.css)`
    display: none;
  `;

exports.wizardLineLastStep = wizardLineLastStep;

const wizardLineVertical = ({
  direction
}) => direction === 'vertical' && (0, _stylitas.css)`
    border-width: 0 1px 0 0;
    width: 1px;
    height: 100%;
  `;

exports.wizardLineVertical = wizardLineVertical;

const wizardLineCustom = ({
  theme,
  variant,
  color
}) => variant === 'custom' && (0, _stylitas.css)`
    border-color: ${color ? _stylitas.utilities.palette.color(theme, color) : theme.bColorneutral05};
  `;

exports.wizardLineCustom = wizardLineCustom;

const wizardStep = ({
  lastStep
}) => (0, _stylitas.css)`
  display: flex;
  flex: ${lastStep ? 'none' : '1'};
  align-items: center;
`;

exports.wizardStep = wizardStep;

const wizardVerticalStepsContainer = () => (0, _stylitas.css)`
  display: flex;
  flex-direction: column;
`;

exports.wizardVerticalStepsContainer = wizardVerticalStepsContainer;

const wizardVerticalStepsContainerAdornment = () => (0, _stylitas.css)`
  width: 32px;
  margin: 0 48px 0 16px;

  div {
    flex-direction: column;
    height: 100%;
  }
`;

exports.wizardVerticalStepsContainerAdornment = wizardVerticalStepsContainerAdornment;

const wizardVerticalStepsContainerWrapper = () => (0, _stylitas.css)`
  display: flex;
`;

exports.wizardVerticalStepsContainerWrapper = wizardVerticalStepsContainerWrapper;

const wizardVerticalStepsContainerContent = () => (0, _stylitas.css)`
  width: 100%;
  margin-bottom: 16px;
`;

exports.wizardVerticalStepsContainerContent = wizardVerticalStepsContainerContent;